import StockValueWidget from "./StockValueWidget.vue";
import News from "./News.vue";

// Katalog der verfügbaren Dashboard-Widgets. Neue Widgets hier eintragen, dann stehen sie
// automatisch im Picker und lassen sich auf jedem konfigurierbaren Dashboard verwenden.
// permission (optional): Widget ist nur nutzbar/sichtbar, wenn der Benutzer dieses Recht hat.
export const widgetRegistry = {
  stockValue: {
    component: StockValueWidget,
    titleKey: "stockValue.title",
    icon: "inventory_2",
    defaultW: 6,
    defaultH: 12,
    minW: 3,
    minH: 8,
  },
  news: {
    component: News,
    titleKey: "news.news",
    icon: "campaign",
    defaultW: 6,
    defaultH: 12,
    minW: 3,
    minH: 6,
    permission: { permissionName: "LimitRead", tableName: "Dashboard", columnName: "News" },
  },
};

export const widgetTypes = Object.keys(widgetRegistry);
